var React = require('react');

function IconCrossOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.1055 1L12.9996 7.10756L6.89202 1H1V6.89202L7.10757 13.0004L1 19.108V25.0008H6.89202L12.9996 18.8924L19.1055 25.0008H25V19.108L18.8924 13.0004L25 6.89202V1H19.1055Z","stroke":"#1D46E3"}));
}

IconCrossOutline.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = IconCrossOutline;

IconCrossOutline.default = IconCrossOutline;
